import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
	DataGrid,
	GridToolbarContainer,
	GridActionsCellItem,
} from "@mui/x-data-grid";
import { Button, Chip } from "@mui/material";

const TaskTable = ({
	tasks,
	t,
	setDialogType,
	toggleDialogIsOpen,
	deleteTask,
	setDialogData,
	resetDialogData,
	copyTask,
}) => {
	const addTaskButtonHandler = () => {
		resetDialogData();
		setDialogType("add");
		toggleDialogIsOpen();
	};

	const editTaskButtonHandler = (id) => {
		const task = tasks.find((task) => task.url === id);
		setDialogData(task);
		setDialogType("edit");
		toggleDialogIsOpen();
	};

	const TaskToolbar = () => {
		return (
			<GridToolbarContainer>
				<Button
					color="primary"
					size="small"
					startIcon={<AddIcon />}
					onClick={addTaskButtonHandler}
				>
					{t("Add Task")}
				</Button>
			</GridToolbarContainer>
		);
	};

	const columns = [
		{
			field: "status",
			headerName: t("Status"),
			minWidth:200,
			flex: 1,
			renderCell: (params) => {
				return (
					<>
						{params.value === "OPEN" && <Chip label={t(params.value)}/>}
						{params.value === "CLOSED" && <Chip label={t(params.value)} color='success'/>}
						{params.value === "IN_PROGRESS" && <Chip label={t(params.value).replace("_", " ")} color='primary'/>}
					</>
				);
			},
		},
		{
			field: "description",
			headerName: t("Description"),
			minWidth:200,
			flex: 1,
		},
		{
			field: "location",
			headerName: t("Location"),
			minWidth:200,
			flex: 1,
		},
		{
			field: "system",
			headerName: t("System"),
			minWidth:200,
			flex: 1,
		},
		{
			field: "device",
			headerName: t("Device"),
			minWidth:200,
			flex: 1,
		},
		{
			field: "actions",
			type: "actions",
			headerName: t("Actions"),
			flex: 0.5,
			minWidth: 150,
			maxWidth: 150,
			cellClassName: "actions",
			getActions: ({ id }) => {
				return [
					<GridActionsCellItem
						icon={<EditIcon />}
						label={t("Edit")}
						className="textPrimary"
						onClick={() => editTaskButtonHandler(id)}
						color="inherit"
					/>,
					<GridActionsCellItem
						icon={<ContentCopyIcon />}
						label={t("Copy")}
						onClick={() => copyTask(id)}
						color="inherit"
					/>,
					<GridActionsCellItem
						icon={<DeleteIcon />}
						label={t("Delete")}
						onClick={() => deleteTask(id)}
						color="inherit"
					/>,
				];
			},
		},
	];

	return (
		<DataGrid
			columns={columns}
			rows={tasks}
			getRowId={(row) => row.url}
			components={{
				Toolbar: TaskToolbar,
			}}
			autoPageSize
			initialState={{
				pagination: {
					paginationModel: {
						pageSize: 5,
					},
				},
			}}
			pageSizeOptions={[5]}
		/>
	);
};

export default TaskTable;
